import { render, staticRenderFns } from "./jdk-list.vue?vue&type=template&id=96e03d52&scoped=true&"
import script from "./jdk-list.vue?vue&type=script&lang=js&"
export * from "./jdk-list.vue?vue&type=script&lang=js&"
import style0 from "./jdk-list.vue?vue&type=style&index=0&id=96e03d52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96e03d52",
  null
  
)

export default component.exports